// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Divider,
  Button,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
// import MDBadge from "theme/components/MDBadge";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";
import AppConfig from "appConfig";
import MessageDialog from "app/components/message_dialog";

function AgentGroup() {
  const pageTitle = "Agent Group";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const auth = useAuthUser();
  const accountInfo = auth();

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [openNewCheckDialog, setOpenNewCheckDialog] = useState(false);

  const [refreshPage, setRefreshPage] = useState(false);
  const [accountAgentGroup, setAccountAgentGroup] = useState({});
  const [agentGroup, setAgentGroup] = useState({});
  const [customFields, setCustomFields] = useState([]);
  const [agents, setAgents] = useState([]);
  const [groupLeads, setGroupLeads] = useState([]);
  const [lastName, setLastName] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [staffNumber, setStaffNumber] = useState(null);
  const [customFieldsRaw, setCustomFieldsRaw] = useState([]);
  const [customFieldValues, setCustomFieldValues] = useState({});

  const [customFieldTitle, setCustomFieldTitle] = useState(null);
  const [customFieldOptions, setCustomFieldOptions] = useState(null);
  const [selectedCustomField, setSelectedCustomField] = useState(null);
  const [openNewFieldDialog, setOpenNewFieldDialog] = useState(false);
  const [openEditFieldDialog, setOpenEditFieldDialog] = useState(false);

  const [selectedAgents, setSelectedAgents] = useState([]);
  const [openMoreActionsDialog, setOpenMoreActionsDialog] = useState(false);

  const [leadCommission, setLeadCommission] = useState(0);
  const [leadCommissionPercentage, setLeadCommissionPercentage] = useState(false);

  const [openUploadAgentsDialog, setOpenUploadAgentsDialog] = useState(false);
  const [openAssignLeadDialog, setOpenAssignLeadDialog] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  const [showMessageComponentDialog, setShowMessageComponentDialog] = useState(false);
  const [messageDestinationType, setMessageDestinationType] = useState("group.agents");
  const [messageDestinationKey, setMessageDestinationKey] = useState(ref);
  const [messageDestinationDescription, setMessageDestinationDescription] = useState(null);

  const selectionMax = 100;

  async function deleteCustomField(reference) {
    setShowLoading(true);
    await axios
      .get(`portal/agents/groups/fields/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteGroup() {
    setShowLoading(true);

    await axios
      .get(`portal/agents/groups/${ref}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeAgent(reference) {
    setShowLoading(true);
    const json = {
      agent: reference,
      group: ref,
    };
    await axios
      .post(`portal/agents/groups/removeAgent.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignGroupLead() {
    setOpenAssignLeadDialog(false);
    setShowLoading(true);
    const json = {
      agent: selectedAgent,
      group: ref,
      commission: leadCommission,
      is_commission_percentage: leadCommissionPercentage,
    };
    await axios
      .post(`portal/agents/groups/assignGroupLead.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeGroupLead(reference) {
    setShowLoading(true);
    const json = {
      agent: reference,
      group: ref,
    };
    await axios
      .post(`portal/agents/groups/removeGroupLead.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function addAgentChecked(reference) {
    const myArray = selectedAgents;
    const index = myArray.indexOf(reference);
    if (index > 0) {
      return true;
    }

    if (myArray.length >= selectionMax) {
      setSeverity("error");
      setErrMsg(`A maximum of ${selectionMax} agents can be selected at a time.`);
      setOpen(true);
      return false;
    }
    myArray.push(reference);
    setSelectedAgents(myArray);
    // console.log(myArray.length);
    return true;
  }

  function removeAgentChecked(reference) {
    const myArray = selectedAgents;
    const index = myArray.indexOf(reference);
    if (index < 0) {
      return;
    }

    myArray.splice(index, 1);
    // console.log(myArray);
    setSelectedAgents(myArray);
  }

  const tableColumns = [
    { Header: "#", accessor: "id", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    // { Header: "Last Name", accessor: "last_name", align: "left" },
    // { Header: "First Name", accessor: "first_name", align: "left" },
    { Header: "Email", accessor: "email_address", align: "left" },
    // { Header: "Phone", accessor: "phone_number", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Action", accessor: "action", align: "center" },
    { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        // currency: <b>{echeck.currency.currency_code}</b>,
        id: (
          <Checkbox
            // checked={isPublic}
            onClick={(e) => {
              if (e.target.checked) {
                const checked = addAgentChecked(row.reference);
                e.target.checked = checked;
                if (!checked) {
                  e.preventDefault();
                }
              } else {
                removeAgentChecked(row.reference);
              }
            }}
          />
        ),
        name: `${row.agent.last_name} ${row.agent.first_name}`,
        // last_name: row.agent.last_name,
        // first_name: row.agent.first_name,
        email_address: row.agent.email_address,
        phone_number: row.agent.phone_number,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        action: (
          <MDBox mt={1} variant="button">
            <Tooltip title="View Agent">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  navigate(`/agents/${row.agent.reference}`);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>visibility</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Send Message">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  setMessageDestinationType("group.agent");
                  setMessageDestinationKey(row.reference);
                  setMessageDestinationDescription(
                    `Send message to ${row.agent.last_name} ${row.agent.first_name}?`
                  );
                  AppConfig.messageDialogShown = true;
                  setShowMessageComponentDialog(true);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Assign Group Lead">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  if (
                    window.confirm(
                      `Assign ${row.agent.last_name} ${row.agent.first_name} as group lead?`
                    ) === true
                  ) {
                    setLeadCommission(0);
                    setLeadCommissionPercentage(false);
                    setSelectedAgent(row.reference);
                    setOpenAssignLeadDialog(true);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  local_police
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Remove From Group">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (
                    window.confirm(`Remove ${row.agent.last_name} ${row.agent.first_name}?`) ===
                    true
                  ) {
                    removeAgent(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  close
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const leadTableColumns = [
    { Header: "#", accessor: "id", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    // { Header: "Last Name", accessor: "last_name", align: "left" },
    // { Header: "First Name", accessor: "first_name", align: "left" },
    { Header: "Email", accessor: "email_address", align: "left" },
    // { Header: "Phone", accessor: "phone_number", align: "left" },
    { Header: "Commission", accessor: "commission", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "action", align: "center" },
    { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildLeadsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        id: (
          <Checkbox
            // checked={isPublic}
            onClick={(e) => {
              if (e.target.checked) {
                const checked = addAgentChecked(row.reference);
                e.target.checked = checked;
                if (!checked) {
                  e.preventDefault();
                }
              } else {
                removeAgentChecked(row.reference);
              }
            }}
          />
        ),
        name: `${row.agent.last_name} ${row.agent.first_name}`,
        // last_name: row.agent.last_name,
        // first_name: row.agent.first_name,
        email_address: row.agent.email_address,
        phone_number: row.agent.phone_number,
        commission: (
          <span>
            {!row.is_commission_percentage
              ? `N${(row.commission / 100).toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : `${(row.commission * 100).toLocaleString("en", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}%`}
          </span>
        ),
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        action: (
          <MDBox mt={1} variant="button">
            <Tooltip title="View Agent">
              <MDButton
                size="small"
                variant="outlined"
                color="info"
                iconOnly
                onClick={() => {
                  navigate(`/agents/${row.agent.reference}`);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>visibility</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Send Message">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  setMessageDestinationType("group.agent");
                  setMessageDestinationKey(row.reference);
                  setMessageDestinationDescription(
                    `Send message to ${row.agent.last_name} ${row.agent.first_name}?`
                  );
                  AppConfig.messageDialogShown = true;
                  setShowMessageComponentDialog(true);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Unassign Group Lead">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  if (
                    window.confirm(
                      `Unassign ${row.agent.last_name} ${row.agent.first_name} as group lead?`
                    ) === true
                  ) {
                    removeGroupLead(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  close
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Remove From Group">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (
                    window.confirm(`Remove ${row.agent.last_name} ${row.agent.first_name}?`) ===
                    true
                  ) {
                    removeAgent(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  delete
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  const customFieldTableColumns = [
    { Header: "Field", accessor: "field", align: "left" },
    { Header: "Key", accessor: "code", align: "left" },
    { Header: "Options", accessor: "options", align: "left" },
    { Header: "Actions", accessor: "action", align: "right" },
    // { Header: "Added On", accessor: "created", align: "right" },
  ];

  const buildCustomFieldRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        field: row.title,
        code: row.code,
        options: row.options.length > 0 ? row.options.join(",") : "---",
        action: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Edit">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  setSelectedCustomField(row);
                  setCustomFieldTitle(row.title);
                  setCustomFieldOptions(row.options.length > 0 ? row.options.join(",") : null);
                  setOpenEditFieldDialog(true);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  edit_note
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <MDButton
                size="small"
                variant="outlined"
                color="error"
                iconOnly
                onClick={() => {
                  if (window.confirm(`Remove ${row.title}?`) === true) {
                    deleteCustomField(row.reference);
                  }
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                  delete
                </Icon>
              </MDButton>
            </Tooltip>
          </MDBox>
        ),
        created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/agents/groups/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setAccountAgentGroup(result.data.data.agent_group);
            setAgentGroup(result.data.data.agent_group.agent_group);
            setCustomFieldsRaw(result.data.data.custom_fields);

            const rowsF = buildCustomFieldRows(result.data.data.custom_fields);
            setCustomFields(rowsF);

            const rows = buildRateRows(result.data.data.agents);
            setAgents(rows);

            const rowsL = buildLeadsRows(result.data.data.leads);
            setGroupLeads(rowsL);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createAgent() {
    if (lastName === null) {
      setSeverity("error");
      setErrMsg("Last name is required.");
      setOpen(true);
      return;
    }

    if (firstName === null) {
      setSeverity("error");
      setErrMsg("First name is required.");
      setOpen(true);
      return;
    }

    if (emailAddress === null) {
      setSeverity("error");
      setErrMsg("Email address is required.");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Phone number is required.");
      setOpen(true);
      return;
    }

    if (customFieldsRaw.length > 0) {
      /* eslint-disable no-restricted-syntax */
      for (const f of customFieldsRaw) {
        if (
          typeof customFieldValues[f.reference] === "undefined" ||
          customFieldValues[f.reference].length <= 0
        ) {
          setSeverity("error");
          setErrMsg(`${f.title} is required.`);
          setOpen(true);
          return;
        }
      }
    }

    setOpenNewCheckDialog(false);
    setShowLoading(true);
    const json = {
      last_name: `${lastName}`,
      first_name: `${firstName}`,
      email_address: `${emailAddress}`,
      phone_number: `${phoneNumber}`,
      staff_number: `${staffNumber}`,
      group: ref,
      custom_fields: customFieldValues,
    };

    await axios
      .post("portal/agents/groups/createAgent.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg("Agent created!");
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function postData(formData) {
    setShowLoading(true);
    await axios
      .post("portal/agents/groups/uploadAgent.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadAgents = () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("group", ref);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadAgentsDialog(false);
    setShowLoading(true);

    postData(formData);
  };

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }
    setUploadFile(e.target.files[0]);
  }

  async function bulkRemove() {
    if (window.confirm(`Warning! This action cannot be undone. Proceed?`) === false) {
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      reference: accountAgentGroup.reference,
    };

    await axios
      .post(`portal/agents/bulk/action/group/remove.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkRemoveSelected() {
    if (selectedAgents.length <= 0) {
      setSeverity("error");
      setErrMsg("No agents selected.");
      setOpen(true);
      return;
    }

    if (window.confirm(`Warning! This action cannot be undone. Proceed?`) === false) {
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      reference: accountAgentGroup.reference,
      agents: selectedAgents,
    };

    await axios
      .post(`portal/agents/bulk/action/group/remove/selected.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkStatusUpdate(statusUpdate) {
    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      status: statusUpdate,
      reference: accountAgentGroup.reference,
    };

    await axios
      .post(`portal/agents/bulk/action/group/status.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkStatusUpdateSelected(statusUpdate) {
    if (selectedAgents.length <= 0) {
      setSeverity("error");
      setErrMsg("No agents selected.");
      setOpen(true);
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      status: statusUpdate,
      agents: selectedAgents,
      reference: accountAgentGroup.reference,
    };

    console.log(json);

    await axios
      .post(`portal/agents/bulk/action/group/status/selected.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkDelete() {
    if (window.confirm(`Warning! This action cannot be undone. Proceed?`) === false) {
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      reference: accountAgentGroup.reference,
    };

    await axios
      .post(`portal/agents/bulk/action/group/delete.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function bulkDeleteSelected() {
    if (selectedAgents.length <= 0) {
      setSeverity("error");
      setErrMsg("No agents selected.");
      setOpen(true);
      return;
    }

    if (window.confirm(`Warning! This action cannot be undone. Proceed?`) === false) {
      return;
    }

    setOpenMoreActionsDialog(false);
    setShowLoading(true);

    const json = {
      reference: accountAgentGroup.reference,
      agents: selectedAgents,
    };

    await axios
      .post(`portal/agents/bulk/action/group/delete/selected.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createCustomField() {
    if (customFieldTitle === null) {
      setSeverity("error");
      setErrMsg("Field name is required.");
      setOpen(true);
      return;
    }

    setOpenNewFieldDialog(false);
    setShowLoading(true);
    const json = {
      name: customFieldTitle,
      options: customFieldOptions,
      group: agentGroup.reference,
    };

    await axios
      .post("portal/agents/groups/fields/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editCustomField() {
    if (customFieldTitle === null) {
      setSeverity("error");
      setErrMsg("Field name is required.");
      setOpen(true);
      return;
    }

    setOpenEditFieldDialog(false);
    setShowLoading(true);
    const json = {
      name: customFieldTitle,
      options: customFieldOptions,
      reference: selectedCustomField.reference,
    };

    await axios
      .post("portal/agents/groups/fields/edit.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MessageDialog
        destinationType={messageDestinationType}
        destinationKey={messageDestinationKey}
        description={messageDestinationDescription}
        displayState={showMessageComponentDialog}
        setDisplayState={setShowMessageComponentDialog}
      />
      <Dialog open={openNewCheckDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>New Agent</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={2}>
              <MDInput
                name="last_name"
                margin="dense"
                label="Last Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setLastName(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                name="first_name"
                margin="dense"
                label="First Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setFirstName(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                name="email_address"
                margin="dense"
                label="Email Address"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setEmailAddress(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                name="phone_number"
                margin="dense"
                label="Phone Number"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </MDBox>
            <MDBox mb={5}>
              <MDInput
                placeholder="Staff ID"
                name="staff_number"
                margin="dense"
                label="Staff Number (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setStaffNumber(e.target.value)}
              />
            </MDBox>
            {customFieldsRaw.map((cField) => {
              if (cField.options.length > 0) {
                return (
                  <MDBox mb={3}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>{cField.title}</InputLabel>
                      <Select
                        label={cField.title}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                        onChange={(e) => {
                          const tmp = customFieldValues;
                          tmp[cField.reference] = e.target.value;
                          // console.log(tmp);
                          setCustomFieldValues(tmp);
                        }}
                      >
                        {cField.options.map((opt) => (
                          <MenuItem value={opt}>{opt}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                );
              }

              return (
                <MDBox mb={3}>
                  <MDInput
                    margin="dense"
                    label={cField.title}
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => {
                      const tmp = customFieldValues;
                      tmp[cField.reference] = e.target.value;
                      // console.log(tmp);
                      setCustomFieldValues(tmp);
                    }}
                  />
                </MDBox>
              );
            })}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewCheckDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createAgent();
            }}
          >
            Add Agent
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewFieldDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Custom Field</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={3}>
              <MDInput
                name="field_name"
                margin="dense"
                label="Field Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setCustomFieldTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                multiline
                minRows={3}
                placeholder="Comma separated values"
                name="field_options"
                margin="dense"
                label="Field Options (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setCustomFieldOptions(e.target.value)}
              />
              <small>Comma separated values</small>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewFieldDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createCustomField();
            }}
          >
            Add Field
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditFieldDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Edit Custom Field</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={3}>
              <MDInput
                name="field_name"
                margin="dense"
                label="Field Name"
                type="text"
                fullWidth
                variant="outlined"
                value={customFieldTitle}
                onChange={(e) => setCustomFieldTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                multiline
                minRows={3}
                placeholder="Comma separated values"
                name="field_options"
                margin="dense"
                label="Field Options (Optional)"
                type="text"
                fullWidth
                variant="outlined"
                value={customFieldOptions}
                onChange={(e) => setCustomFieldOptions(e.target.value)}
              />
              <small>Comma separated values</small>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditFieldDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              editCustomField();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadAgentsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Agents</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={4}>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
                fullWidth
              />
            </MDBox>
            <MDBox mt={3} pl={3} align="center">
              <a
                href={`${AppConfig.api_media_url}documents/templates/agent_upload_template.csv`}
                target="_blank"
                rel="noreferrer"
              >
                == Download Sample Template ==
              </a>
            </MDBox>
            <MDBox mt={3}>
              <MDTypography variant="subtitle2" fontSize={14}>
                <b>Important!</b>
                <br />
                Include your custom field keys as columns in your csv/excel upload file.
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadAgentsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              uploadAgents();
            }}
          >
            Upload Agents
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAssignLeadDialog}>
        <DialogTitle>
          <MDBox>Assign Group Lead</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mb={2}>
              <MDInput
                value={leadCommission}
                name="commission"
                margin="dense"
                label="Commission"
                type="decimal"
                fullWidth
                variant="outlined"
                onChange={(e) => setLeadCommission(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={leadCommissionPercentage}
                onChange={() => setLeadCommissionPercentage(!leadCommissionPercentage)}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Is commission percentage?
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAssignLeadDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignGroupLead();
            }}
          >
            Assign Agent
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openMoreActionsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Perform Bulk Action</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={1} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Remove only selected agents from group
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkRemoveSelected();
                    }
                  }}
                  color="warning"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>close</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Remove all agents from group
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkRemove();
                    }
                  }}
                  color="warning"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>close</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3}>
              <Divider />
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Disable only selected agents in group
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdateSelected(false);
                    }
                  }}
                  color="info"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>pause</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Disable all agents in group
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdate(false);
                    }
                  }}
                  color="info"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>pause</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3}>
              <Divider />
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Enable only selected agents in group
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdateSelected(true);
                    }
                  }}
                  color="success"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>play_arrow</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular">
                Enable all agents in group
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkStatusUpdate(true);
                    }
                  }}
                  color="success"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>play_arrow</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3}>
              <Divider />
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular" color="error">
                Delete only selected agents from account
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkDeleteSelected();
                    }
                  }}
                  color="error"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>delete</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={3} display="flex" justifyContent="space-between" alignItems="center">
              <MDTypography variant="h6" fontWeight="regular" color="error">
                Delete all agents from account
              </MDTypography>
              <MDBox>
                <MDButton
                  onClick={() => {
                    if (window.confirm("Proceed with this action?") === true) {
                      bulkDelete();
                    }
                  }}
                  color="error"
                  variant="outlined"
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>delete</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenMoreActionsDialog(false);
            }}
            color="dark"
            variant="outlined"
            iconOnly
            circular
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pb={3}>
        <MDBox mt={2} mb={3} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                if (window.history.length > 1) {
                  window.history.back();
                } else {
                  navigate(`/agent-groups`);
                }
              }}
            >
              Back
            </Button>
          </MDBox>
          <MDBox>
            <Button
              size="small"
              color="warning"
              iconOnly
              onClick={() => {
                navigate(`/agent-groups/insights/${ref}`);
              }}
              startIcon={
                <Icon sx={{ cursor: "pointer" }} fontSize="small" color="warning">
                  bar_chart
                </Icon>
              }
            >
              Group Performance
            </Button>
          </MDBox>
        </MDBox>
        <MDBox>
          <Card sx={{ height: "100%", marginTop: "0px" }}>
            <MDBox p={3}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6" fontWeight="medium">
                  {agentGroup.title}
                </MDTypography>
                <MDBox>
                  <Tooltip title="Message Agents">
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setMessageDestinationType("group.agents");
                        setMessageDestinationKey(ref);
                        setMessageDestinationDescription("Send message to all group members");
                        AppConfig.messageDialogShown = true;
                        setShowMessageComponentDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
                    </MDButton>
                  </Tooltip>
                  &nbsp;
                  <Tooltip title="Download Agents">
                    <MDButton
                      variant="contained"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        const downloadUrl = `${AppConfig.api_base_url}portal/agents/groups/${ref}/${accountInfo.user.reference}/export.json`;
                        window.open(downloadUrl, "_blank");
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                    </MDButton>
                  </Tooltip>
                  &nbsp;
                  <Tooltip title="Delete Group">
                    <MDButton
                      variant="contained"
                      color="error"
                      iconOnly
                      onClick={() => {
                        if (window.confirm("Delete Group?") === true) {
                          deleteGroup(ref);
                        }
                      }}
                    >
                      <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                        delete
                      </Icon>
                    </MDButton>
                  </Tooltip>
                  &nbsp;&nbsp;
                  <Tooltip title="Bulk Actions">
                    <MDButton
                      variant="outlined"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setOpenMoreActionsDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>more_vert</Icon>
                    </MDButton>
                  </Tooltip>
                </MDBox>
              </MDBox>
              <MDBox mt={3}>
                <a href={agentGroup.join_link} target="_blank" rel="noreferrer">
                  <MDTypography variant="caption" fontWeight="light">
                    <b>Join Link:</b> &nbsp;{agentGroup.join_link}
                  </MDTypography>
                </a>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
      </MDBox>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="medium">
                            Custom Fields
                          </MDTypography>
                          <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                            Create custom classification fields for your agents. Improve
                            organization, filtration and reporting.
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Tooltip title="Add Field">
                            <MDButton
                              variant="contained"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                setCustomFieldTitle(null);
                                setCustomFieldOptions(null);
                                setOpenNewFieldDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </Tooltip>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: customFieldTableColumns, rows: customFields }}
                          isSorted
                          canSearch={false}
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium">
                          Group Leads
                        </MDTypography>
                        {/* <MDBox>
                          <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setOpenNewCheckDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                          &nbsp;&nbsp;
                          <MDButton
                            variant="outlined"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setOpenUploadAgentsDialog(true);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                          </MDButton>
                        </MDBox> */}
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: leadTableColumns, rows: groupLeads }}
                          isSorted
                          entriesPerPage
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium">
                          Group Members
                        </MDTypography>
                        <MDBox>
                          <Tooltip title="Add Agent">
                            <MDButton
                              variant="contained"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                setOpenNewCheckDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </Tooltip>
                          &nbsp;
                          <Tooltip title="Upload Agents">
                            <MDButton
                              variant="outlined"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                setOpenUploadAgentsDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                            </MDButton>
                          </Tooltip>
                        </MDBox>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: agents }}
                          isSorted
                          entriesPerPage
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AgentGroup;
